import { render, staticRenderFns } from "./ManageBots.vue?vue&type=template&id=0794c6c2&scoped=true"
import script from "./ManageBots.vue?vue&type=script&lang=js"
export * from "./ManageBots.vue?vue&type=script&lang=js"
import style0 from "./ManageBots.vue?vue&type=style&index=0&id=0794c6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794c6c2",
  null
  
)

export default component.exports